export const MERGE_FROM_DEVICE_REQUEST = 'MERGE_FROM_DEVICE_REQUEST';
export const MERGE_FROM_DEVICE_SUCCESS = 'MERGE_FROM_DEVICE_SUCCESS';
export const MERGE_FROM_DEVICE_FAILURE = 'MERGE_FROM_DEVICE_FAILURE';

export const DELETE_ALL_SYNC_SONGS_REQUEST = 'DELETE_ALL_SYNC_SONGS_REQUEST';
export const DELETE_ALL_SYNC_SONGS_SUCCESS = 'DELETE_ALL_SYNC_SONGS_SUCCESS';
export const DELETE_ALL_SYNC_SONGS_FAILURE = 'DELETE_ALL_SYNC_SONGS_FAILURE';
